import * as fromDatatype from '../datatype-library/index';

export interface bl_applet_login_subject_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  link_type: fromDatatype.VarcharDatatypeInterface;
  app_login_guid: fromDatatype.GuidDataFieldInterface;
  applet_catalog_link_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  rank: fromDatatype.VarcharDatatypeInterface;
  comments: fromDatatype.TextDatatypeInterface;
  rating: fromDatatype.IntegerDatatypeInterface;
  comment_date: fromDatatype.TimestampTzDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  applet_hdr_guid: fromDatatype.GuidDataFieldInterface;
  tenant_guid: fromDatatype.GuidDataFieldInterface;
  applet_catalog_guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  default_language_guid: fromDatatype.GuidDataFieldInterface;
  default_language_code: fromDatatype.VarcharDatatypeInterface;
}

export class bl_applet_login_subject_link_RowClass
  implements bl_applet_login_subject_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  link_type: fromDatatype.VarcharDatatypeInterface;
  app_login_guid: fromDatatype.GuidDataFieldInterface;
  applet_catalog_link_guid: fromDatatype.GuidDataFieldInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  rank: fromDatatype.VarcharDatatypeInterface;
  comments: fromDatatype.TextDatatypeInterface;
  rating: fromDatatype.IntegerDatatypeInterface;
  comment_date: fromDatatype.TimestampTzDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  applet_hdr_guid: fromDatatype.GuidDataFieldInterface;
  tenant_guid: fromDatatype.GuidDataFieldInterface;
  applet_catalog_guid: fromDatatype.GuidDataFieldInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  default_language_guid: fromDatatype.GuidDataFieldInterface;
  default_language_code: fromDatatype.VarcharDatatypeInterface;
}
